import type { IconDef } from '../types';

export const starFilled: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M18.2091 21.9941C18.0573 21.9941 17.9055 21.9579 17.7632 21.8946L11.9953 19.0009L6.22733 21.8946C5.90478 22.0574 5.51583 22.0303 5.23122 21.8223C4.93714 21.6233 4.79484 21.2797 4.85176 20.9361L5.95222 14.814L1.28475 10.4733C1.02861 10.2291 0.93374 9.87647 1.04758 9.54188C1.16142 9.21633 1.45551 8.97217 1.81601 8.92695L8.26697 8.03169L11.1509 2.46119C11.4735 1.84627 12.536 1.84627 12.8491 2.46119L15.733 8.03169L22.184 8.92695C22.5445 8.97217 22.8386 9.21633 22.9524 9.54188C23.0663 9.86743 22.9714 10.2291 22.7153 10.4733L18.0478 14.814L19.1482 20.9361C19.2052 21.2797 19.0629 21.6143 18.7688 21.8223C18.6075 21.9398 18.4083 21.9941 18.2091 21.9941Z',
    },
  ],
};
